module.exports = __webpack_public_path__ + "img/game-card-profile-icon-big-light.50b5a655.png";